import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

export default function Verification() {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const email = queryParams.get('email');
  const token = queryParams.get('token');
  const [message, setMessage] = useState('Verifying...');

  useEffect(() => {
    if (!email || !token) {
      setMessage('Invalid verification link.');
      return;
    }

    const verifyUser = async () => {
      try {
        const response = await axios.post(
          'https://orca-app-5i5qx.ondigitalocean.app/api/users/confirmation',
          { email, token },
        );

        setMessage(
          response.data.success
            ? 'Email verified successfully!'
            : response.data.msg,
        );
      } catch (error) {
        setMessage('Something went wrong. Please try again.');
      }
    };

    verifyUser();
  }, [email, token]);

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h2>{message}</h2>
    </div>
  );
}
